// API Configuration
// Use environment variable for API URL, with fallbacks for development
const API_BASE_URL = process.env.REACT_APP_API_URL || (
  process.env.NODE_ENV === 'production'
    ? '' // Empty string means same-origin requests in production
    : 'http://localhost:8000'
);

export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH_SYNC_PROFILE: `${API_BASE_URL}/api/auth/sync-profile`,
  AUTH_PROFILE: `${API_BASE_URL}/api/auth/profile`,
  AUTH_VERIFY_TOKEN: `${API_BASE_URL}/api/auth/verify-token`,
  
  // Intake endpoints
  INTAKE: `${API_BASE_URL}/api/intake`,
  INTAKE_STATUS: `${API_BASE_URL}/api/intake/status`,
  
  // Admin endpoints
  ADMIN_USERS: `${API_BASE_URL}/api/admin/users`,
  ADMIN_ASSESSMENTS: `${API_BASE_URL}/api/admin/assessments`,
  ADMIN_SESSIONS: `${API_BASE_URL}/api/admin/sessions`,
  ADMIN_CONTRACTS: `${API_BASE_URL}/api/admin/contracts`,
  
  // Assessment endpoints
  ASSESSMENTS: `${API_BASE_URL}/api/assessments`,
  
  // Session/Booking endpoints
  SESSIONS: `${API_BASE_URL}/api/sessions`,
  BOOKING: `${API_BASE_URL}/api/booking`,
  
  // Calendar endpoints
  CALENDAR_AUTH_STATUS: `${API_BASE_URL}/api/calendar/auth-status`,
  CALENDAR_AUTH_URL: `${API_BASE_URL}/api/calendar/auth-url`,
  CALENDAR_AUTH_COMPLETE: `${API_BASE_URL}/api/calendar/auth/complete`,
  CALENDAR_SYNC: `${API_BASE_URL}/api/calendar/sync`,
  CALENDAR_SYNC_CLEAR: `${API_BASE_URL}/api/calendar/sync/clear`,
  
  // Progress endpoints
  PROGRESS_GOALS: `${API_BASE_URL}/api/progress/goals`,
  PROGRESS_NOTES: `${API_BASE_URL}/api/progress/notes`,
  PROGRESS_ADMIN_NOTES: `${API_BASE_URL}/api/progress/notes`,
  PROGRESS_CLIENT_NOTES: `${API_BASE_URL}/api/progress/notes/client`,
  
  // Booking system endpoints
  BOOKING_SESSION_TYPES: `${API_BASE_URL}/api/booking/session-types`,
  BOOKING_AVAILABLE_SLOTS: `${API_BASE_URL}/api/booking/available-slots`,
  BOOKING_BOOK_SESSION: `${API_BASE_URL}/api/booking/book-session`,
  BOOKING_MY_SESSIONS: `${API_BASE_URL}/api/booking/my-sessions`,
  BOOKING_SESSION_STATS: `${API_BASE_URL}/api/booking/my-sessions/stats`,

  // File download endpoints
  ASSESSMENTS_DOWNLOAD: `${API_BASE_URL}/api/assessments/download`,

  // Payment endpoints
  PAYMENTS_BALANCE: `${API_BASE_URL}/api/payments/balance`,
  PAYMENTS_HISTORY: `${API_BASE_URL}/api/payments/history`,
  PAYMENTS_PROCESS: `${API_BASE_URL}/api/payments/process`,
  PAYMENTS_CREATE_INTENT: `${API_BASE_URL}/api/payments/create-intent`,
  PAYMENTS_WEBHOOK_STRIPE: `${API_BASE_URL}/api/payments/webhook/stripe`,
};

// Helper function to build dynamic URLs
export const buildApiUrl = (endpoint, params = {}) => {
  let url = `${API_BASE_URL}${endpoint}`;
  
  // Replace path parameters (e.g., /users/:id -> /users/123)
  Object.keys(params).forEach(key => {
    url = url.replace(`:${key}`, params[key]);
  });
  
  return url;
};

// Helper function for common API calls
export const apiCall = async (url, options = {}) => {
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  };
  
  return fetch(url, { ...defaultOptions, ...options });
};

export default API_BASE_URL;